/* BraidingFest v2: motion and live homepage pieces. Everything degrades to a complete static page. */
(function () {
  'use strict';
  var BF = window.BF || {};
  var proxy = BF.proxy || '/apps/braidingfest';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (FINE) document.documentElement.classList.add('bf-fine');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safeHref(v) { var s = String(v || ''); return /^\/(?!\/)/.test(s) || /^https:\/\//.test(s) ? s : '#'; }
  function home() {
    if (BF.getHome) return BF.getHome();
    if (!BF._home) BF._home = fetch(proxy + '/api/home', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); });
    return BF._home;
  }

  /* Loader: once per visit, homepage only */
  function loader() {
    var l = $('[data-loader]');
    if (!l || !document.documentElement.classList.contains('bf-loading')) { heroIn(); return; }
    var w = $('[data-loader-word]', l), txt = w.textContent; w.textContent = '';
    txt.split('').forEach(function (c, i) { var s = document.createElement('span'); s.textContent = c; s.style.animationDelay = (0.1 + i * 0.035) + 's'; w.appendChild(s); });
    var pct = $('[data-loader-pct]', l), n = 0;
    var iv = setInterval(function () { n = Math.min(100, n + Math.floor(Math.random() * 16) + 10); pct.textContent = n < 100 ? 'COUNTING VOTES ' + n + '%' : 'WELCOME'; if (n >= 100) clearInterval(iv); }, 100);
    setTimeout(function () { l.classList.add('done'); heroIn(); try { sessionStorage.setItem('bfSeen', '1'); } catch (e) {} setTimeout(function () { document.documentElement.classList.remove('bf-loading'); }, 900); }, 1400);
  }

  /* Hero headline letters */
  function splitHero() {
    $$('[data-split]').forEach(function (h) {
      if (REDUCE) return;
      $$('.ln', h).forEach(function (ln) {
        var t = ln.textContent.trim(); ln.textContent = '';
        t.split('').forEach(function (c) { var s = document.createElement('span'); s.className = 'ch'; s.textContent = c === ' ' ? ' ' : c; s.setAttribute('aria-hidden', 'true'); ln.appendChild(s); });
        ln.setAttribute('aria-label', t);
      });
      h.classList.add('bf-split');
    });
  }
  function heroIn() { $$('[data-split] .ch').forEach(function (ch, i) { setTimeout(function () { ch.classList.add('up'); }, i * 35); }); }

  /* Custom cursor */
  function cursor() {
    var c = $('[data-cursor]'); if (!c || !FINE) return;
    var cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy;
    addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
    (function loop() { cx += (tx - cx) * 0.25; cy += (ty - cy) * 0.25; c.style.left = cx + 'px'; c.style.top = cy + 'px'; requestAnimationFrame(loop); })();
    document.addEventListener('mouseover', function (e) {
      var t = e.target; if (!t.closest) return;
      var v = t.closest('[data-cursor-vote]');
      c.classList.toggle('vote', !!v);
      c.classList.toggle('big', !v && !!t.closest('a, button, label, summary, [data-tilt]'));
    });
  }

  /* Progress bar + header height for the mobile drawer */
  function chrome() {
    var bar = $('[data-progress]'), hd = $('[data-header]');
    function on() { var h = document.documentElement, p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight); if (bar) bar.style.width = (p * 100) + '%'; if (hd) document.documentElement.style.setProperty('--bf-hh', hd.getBoundingClientRect().bottom + 'px'); }
    addEventListener('scroll', on, { passive: true }); addEventListener('resize', on); on();
    var btn = $('[data-burger]'), dr = $('#BfDrawer');
    if (btn && dr) {
      btn.addEventListener('click', function () { var o = btn.getAttribute('aria-expanded') !== 'true'; btn.setAttribute('aria-expanded', String(o)); dr.setAttribute('data-open', String(o)); document.body.style.overflow = o ? 'hidden' : ''; on(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); } });
    }
  }

  /* Hero collage parallax */
  function parallax() {
    var box = $('[data-parallax]'); if (!box || REDUCE) return;
    var layers = $$('[data-depth]', box), mx = 0, my = 0;
    function set() { var sy = scrollY; if (sy > innerHeight * 1.3) return; layers.forEach(function (el) { var d = +el.getAttribute('data-depth'); el.style.transform = 'translate(' + (mx * d * 60) + 'px,' + (my * d * 60 - sy * d * 1.4) + 'px)'; }); }
    if (FINE) addEventListener('mousemove', function (e) { mx = e.clientX / innerWidth - 0.5; my = e.clientY / innerHeight - 0.5; set(); });
    addEventListener('scroll', set, { passive: true });
  }

  /* Marquee that speeds up with scroll */
  function marquee() {
    $$('[data-marquee]').forEach(function (tr) {
      if (REDUCE) return;
      var pos = 0, vel = 0, last = scrollY;
      (function tick() { var dy = scrollY - last; last = scrollY; vel += dy * 0.08; vel *= 0.9; pos -= 0.7 + Math.abs(vel); var half = tr.scrollWidth / 2; if (half && -pos >= half) pos += half; tr.style.transform = 'translateX(' + pos + 'px)'; requestAnimationFrame(tick); })();
    });
  }

  /* Words light up as they scroll in */
  function words() {
    $$('[data-words]').forEach(function (el) {
      if (REDUCE) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (nd) {
        var or = nd.parentNode.classList && nd.parentNode.classList.contains('or');
        var f = document.createDocumentFragment();
        nd.textContent.split(/(\s+)/).forEach(function (w) { if (!w.trim()) { f.appendChild(document.createTextNode(w)); return; } var s = document.createElement('span'); s.className = 'w' + (or ? ' or' : ''); s.textContent = w; f.appendChild(s); });
        nd.parentNode.replaceChild(f, nd);
      });
      var ws = $$('.w', el);
      function on() { ws.forEach(function (w) { w.classList.toggle('lit', w.getBoundingClientRect().top < innerHeight * 0.82); }); }
      addEventListener('scroll', on, { passive: true }); on();
    });
  }

  /* Reveal + count up */
  function reveal() {
    if (!('IntersectionObserver' in window)) { $$('.bf-reveal').forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.1 });
    $$('.bf-reveal').forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 0.06 + 's'; io.observe(el); });
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) {
      if (!e.isIntersecting) return; var el = e.target, tg = parseInt(el.getAttribute('data-count'), 10); cio.unobserve(el);
      if (REDUCE || !tg) return; var n = 0, st = Math.max(1, Math.ceil(tg / 36)); var iv = setInterval(function () { n = Math.min(tg, n + st); el.textContent = n; if (n >= tg) clearInterval(iv); }, 26);
    }); }, { threshold: 0.6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* Tilt and drag */
  function tilt(root) {
    if (!FINE || REDUCE) return;
    $$('[data-tilt]', root).forEach(function (el) {
      if (el._tilt) return; el._tilt = 1;
      el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5; el.style.transform = 'perspective(900px) rotateY(' + px * 7 + 'deg) rotateX(' + (-py * 7) + 'deg) translateY(-6px)'; });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }
  function drag() {
    $$('[data-drag]').forEach(function (w) {
      var down = false, sx = 0, sl = 0, moved = false;
      w.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = w.scrollLeft; });
      addEventListener('mouseup', function () { down = false; });
      w.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 5) moved = true; w.scrollLeft = sl - dx * 1.3; e.preventDefault(); });
      w.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      w.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* The Board: split-flap leaderboard fed by live votes */
  var CHARS = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#-';
  function pad(s, w) { s = String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); return (s + ' '.repeat(w)).slice(0, w); }
  function lpad(s, w) { s = String(s); return (' '.repeat(w) + s).slice(-w); }
  function flaps(n, cls) { var h = '<div class="bf-flaps ' + (cls || '') + '">'; for (var i = 0; i < n; i++) h += '<span class="bf-flap"> </span>'; return h + '</div>'; }
  function setFlaps(box, text) {
    var fl = box.querySelectorAll('.bf-flap');
    text.split('').forEach(function (ch, i) {
      var f = fl[i]; if (!f || f.textContent === ch) return;
      if (REDUCE) { f.textContent = ch; return; }
      var steps = 3 + Math.floor(Math.random() * 6), k = 0;
      (function step() { k++; f.textContent = k >= steps ? ch : CHARS[Math.floor(Math.random() * CHARS.length)]; f.classList.remove('flip'); void f.offsetWidth; f.classList.add('flip'); if (k < steps) setTimeout(step, 55 + i * 4); })();
    });
  }
  function board() {
    var root = $('[data-board]'); if (!root) return;
    var NAME = 13, CITY = 12, VOTES = 5, ROWS = 5;
    var rowsEl = $('[data-board-rows]', root), tabs = $('[data-board-tabs]', root);
    var rows = [], started = false, lb = null, cur = 0, pg = 0, RW = 2, timer = null, hold = false;
    var empty = (root.getAttribute('data-empty') || 'Nominees coming soon').split(' ');
    /* Phones: names and cities wrap onto a second row of tiles at the space between words, so each tile stays big enough to read. */
    var mq = window.matchMedia ? matchMedia('(max-width: 600px)') : { matches: false }, PH = mq.matches, NL = 14, CL = 17, NLINES = 1, CLINES = 1;
    function lines() { NLINES = NAME > NL ? 2 : 1; CLINES = CITY > CL ? 2 : 1; }
    function wrap(v, per, n) {
      var words = String(v || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim().split(/\s+/).filter(Boolean), out = [], line = '';
      words.forEach(function (w) {
        while (w.length > per) { if (line) { out.push(line); line = ''; } out.push(w.slice(0, per)); w = w.slice(per); }
        if (!line) line = w; else if ((line + ' ' + w).length <= per) line += ' ' + w; else { out.push(line); line = w; }
      });
      if (line) out.push(line);
      return out.slice(0, n).map(function (l) { return (l + ' '.repeat(per)).slice(0, per); }).join('') + ' '.repeat(Math.max(0, (n - out.length) * per));
    }
    function nameText(v) { return PH ? wrap(v, NL, NLINES) : pad(v, NAME); }
    function cityText(v) { return PH ? wrap(v, CL, CLINES) : pad(v, CITY); }
    /* Each row: rank | name over city | votes. Widths follow the longest name and city so nothing is cut off. */
    function build() {
      var html = '';
      PH = mq.matches; lines();
      var nN = PH ? NL * NLINES : NAME, nC = PH ? CL * CLINES : CITY;
      for (var i = 0; i < ROWS; i++) html += '<div class="bf-brow' + (i === 0 ? ' first' : '') + '">' + flaps(RW, 'rank') + '<a class="bf-who" href="' + proxy + '/stylists">' + flaps(nN, 'name') + flaps(nC, 'city') + '</a>' + flaps(VOTES, 'votes') + '<a class="bf-vote" href="' + proxy + '/vote" data-cursor-vote hidden>Vote</a></div>';
      rowsEl.innerHTML = html;
      rows = $$('.bf-brow', rowsEl);
      fit();
    }
    /* Size the flaps so the widest row fits the frame (city flaps are 62% of a name flap). */
    function fit() {
      var w = rowsEl.clientWidth; if (!w) return;
      if (PH) {
        /* rank and votes tiles are 85% wide; 1px gaps; 8px between columns */
        var pu = RW * 0.85 + NL + VOTES * 0.85, pf = 16 + (NL - 1) + 1 + (VOTES - 1) + 2;
        rowsEl.style.setProperty('--fwm', Math.max(10, Math.min(22, Math.floor((w - pf) / pu * 10) / 10)) + 'px');
        rowsEl.style.setProperty('--nl', NL); rowsEl.style.setProperty('--cl', CL);
        return;
      }
      var units = RW + Math.max(NAME, Math.ceil(CITY * 0.62)) + VOTES;
      var fixed = (lb && lb.open ? 84 : 0) + 3 * 12 + units * 2;
      rowsEl.style.setProperty('--fw', Math.max(8, Math.min(26, Math.floor((w - fixed) / units))) + 'px');
    }
    addEventListener('resize', function () { if (mq.matches !== PH) { build(); if (lb && lb.categories) show(cur); else showEmpty(); } else fit(); });
    function showEmpty() {
      rows.forEach(function (r, i) { var bx = $$('.bf-flaps', r); setFlaps(bx[0], pad('', RW)); setFlaps(bx[1], nameText(i === 1 ? empty.slice(0, Math.ceil(empty.length / 2)).join(' ') : i === 2 ? empty.slice(Math.ceil(empty.length / 2)).join(' ') : '')); setFlaps(bx[2], cityText('')); setFlaps(bx[3], pad('', VOTES)); });
    }
    /* Long boards (the Top 100 IE lists every braider) page through 5 at a time: arrows, plus a slow auto-flip. */
    if (!document.getElementById('bf-pager-css')) { var st = document.createElement('style'); st.id = 'bf-pager-css'; st.textContent = 'a.bf-who{color:inherit;text-decoration:none;cursor:pointer}a.bf-who:hover .bf-flaps.name .bf-flap,a.bf-who:focus-visible .bf-flaps.name .bf-flap{color:#FF6A13}a.bf-who[aria-hidden=true]{pointer-events:none}.bf-pager{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0 2px;font-family:"Space Mono",ui-monospace,monospace;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#FAF8FF}.bf-pager[hidden]{display:none}.bf-pager button{min-width:44px;min-height:40px;background:transparent;color:#FAF8FF;border:2px solid rgba(250,248,255,.4);font-size:18px;cursor:pointer}.bf-pager button:hover,.bf-pager button:focus-visible{border-color:#FF6A13;color:#FF6A13}'; document.head.appendChild(st); }
    var pager = document.createElement('div'); pager.className = 'bf-pager'; pager.hidden = true;
    pager.innerHTML = '<button type="button" data-pg="-1" aria-label="Previous five">&larr;</button><span data-pg-label aria-live="polite"></span><button type="button" data-pg="1" aria-label="Next five">&rarr;</button>';
    pager.addEventListener('click', function (e) { var b = e.target.closest('[data-pg]'); if (!b) return; hold = true; page(pg + Number(b.getAttribute('data-pg'))); });
    root.addEventListener('mouseenter', function () { hold = true; }); root.addEventListener('focusin', function () { hold = true; });
    function pages(c) { return Math.max(1, Math.ceil((c.rows || []).length / ROWS)); }
    function page(p) { var c = lb.categories[cur], n = pages(c); pg = (p + n) % n; paint(); }
    function show(i) {
      cur = i; pg = 0; hold = false;
      $$('button', tabs).forEach(function (b, j) { b.setAttribute('aria-selected', String(j === i)); });
      paint();
      clearInterval(timer);
      if (pages(lb.categories[i]) > 1 && !REDUCE) timer = setInterval(function () { if (!hold && !document.hidden) page(pg + 1); }, 7000);
    }
    function paint() {
      var i = cur, c = lb.categories[i], off = pg * ROWS, n = pages(c);
      pager.hidden = n < 2;
      if (n > 1) $('[data-pg-label]', pager).textContent = (off + 1) + '–' + Math.min(off + ROWS, c.rows.length) + ' of ' + c.rows.length;
      rows.forEach(function (row, k) {
        var r = c.rows[off + k], bx = $$('.bf-flaps', row), a = $('.bf-vote', row);
        var who = $('.bf-who', row);
        if (!r) { setFlaps(bx[0], pad('', RW)); setFlaps(bx[1], nameText('')); setFlaps(bx[2], cityText('')); setFlaps(bx[3], pad('', VOTES)); a.hidden = true; row.removeAttribute('aria-label'); who.removeAttribute('href'); who.setAttribute('aria-hidden', 'true'); who.tabIndex = -1; return; }
        var rank = off + k + 1;
        setFlaps(bx[0], lpad(rank < 10 ? '0' + rank : String(rank), RW)); setFlaps(bx[1], nameText(r.name)); setFlaps(bx[2], cityText(r.city)); setFlaps(bx[3], lpad(Number(r.votes || 0), VOTES));
        /* The name opens their profile */
        who.href = safeHref(r.url || proxy + '/stylists'); who.removeAttribute('aria-hidden'); who.removeAttribute('tabindex'); who.setAttribute('aria-label', r.name + ' profile');
        a.hidden = !lb.open; a.href = safeHref(r.voteUrl || proxy + '/vote'); a.setAttribute('aria-label', 'Vote for ' + r.name);
        row.setAttribute('aria-label', rank + '. ' + r.name + (r.city ? ', ' + r.city : '') + ', ' + Number(r.votes || 0) + ' votes');
      });
      var top = c.rows[0], L = $('[data-board-leader]', root);
      if (top && L) {
        L.href = safeHref(top.url);
        $('[data-leader-name]', L).textContent = top.name;
        $('[data-leader-meta]', L).textContent = c.name + (top.city ? ' · ' + top.city : '');
        $('[data-leader-crown]', L).textContent = '#1 · ' + Number(top.votes || 0).toLocaleString() + ' votes';
        var img = $('img', L); if (top.photo && img) { img.removeAttribute('srcset'); img.src = top.photo; }
      }
    }
    function len(v) { return String(v || '').trim().length; }
    function go() {
      if (started) return; started = true;
      home().then(function (d) {
        lb = d && d.leaderboard;
        if (!lb || !lb.categories || !lb.categories.length || !lb.categories.some(function (c) { return c.rows && c.rows.length; })) { showEmpty(); $('[data-board-status]', root).textContent = 'Voting opens soon'; return; }
        lb.categories = lb.categories.filter(function (c) { return c.rows && c.rows.length; }).slice(0, 4);
        lb.categories.forEach(function (c) { if (c.rows.length > 99) RW = 3; c.rows.forEach(function (r) { NAME = Math.max(NAME, Math.min(28, len(r.name))); CITY = Math.max(CITY, Math.min(30, len(r.city))); }); });
        build();
        var foot = $('.bf-board__foot', root); if (foot) foot.parentNode.insertBefore(pager, foot);
        tabs.innerHTML = lb.categories.map(function (c, i) { return '<button type="button" role="tab" aria-selected="false" data-i="' + i + '">' + esc(c.name) + '</button>'; }).join('');
        tabs.addEventListener('click', function (e) { var b = e.target.closest('button[data-i]'); if (b) show(+b.getAttribute('data-i')); });
        if (!lb.open) $('[data-board-status]', root).textContent = lb.paused ? 'Voting opens soon' : 'Final standings';
        if (lb.paused) { var ft = $('.bf-board__foot span', root); if (ft) ft.innerHTML = 'Voting opens soon. <a href="' + proxy + '/vote#nominate">Nominations are open now</a>.'; }
        show(0);
      }).catch(showEmpty);
    }
    build();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { go(); o.disconnect(); } }, { threshold: 0.2 }).observe(root); else go();
  }

  /* Hero chip shows the current #1 */
  function heroChip() {
    var chip = $('[data-hero-chip]'); if (!chip) return;
    home().then(function (d) {
      var lb = d && d.leaderboard; if (!lb || !lb.categories || lb.paused) return;
      var c = lb.categories.filter(function (x) { return x.rows && x.rows.length && Number(x.rows[0].votes || 0) > 0; })[0]; if (!c) return;
      var r = c.rows[0];
      $('[data-chip-label]', chip).textContent = '#1 · ' + c.name;
      $('[data-chip-name]', chip).textContent = r.name;
      $('[data-chip-votes]', chip).textContent = Number(r.votes || 0).toLocaleString() + ' votes';
      chip.href = safeHref(r.url); chip.hidden = false; chip.removeAttribute('tabindex');
    }).catch(function () {});
  }

  /* Braider cards from the directory */
  function braiders() {
    var track = $('[data-braiders]'); if (!track) return;
    var count = +track.getAttribute('data-count') || 8, cols = ['#FF6A13', '#8A2BFF', '#1F5BFF'];
    home().then(function (d) {
      var list = ((d && d.stylists) || []).slice(0, count); if (!list.length) return;
      track.innerHTML = list.map(function (s, i) {
        var badge = s.licensed ? '<span class="badge">Licensed</span>' : '<span class="badge spec">Certified</span>';
        var rk = s.rank ? '<span class="rk">#' + esc(s.rank.rank) + ' ' + esc(s.rank.category) + '</span>' : (s.featured ? '<span class="rk">Featured</span>' : (s.award ? '<span class="rk">' + esc(s.award) + '</span>' : ''));
        var meta = [s.role, s.city].filter(Boolean).map(esc).join(' · ');
        var rating = s.rating ? '★ ' + Number(s.rating).toFixed(1) + ' (' + Number(s.reviews || 0) + ')' : 'New on BraidingFest';
        return '<a class="bf-card" data-tilt href="' + esc(safeHref(s.url)) + '" style="--c:' + cols[i % 3] + '"><div class="pic">' + (s.photo ? '<img src="' + esc(s.photo) + '" alt="' + esc(s.name) + ' braiding work" loading="lazy">' : '') + badge + rk + '</div>' +
          '<div class="meta"><span class="name">' + esc(s.name) + '</span><span class="spec">' + meta + '</span><div class="row2"><span class="stars">' + rating + '</span><span class="mini">' + (s.priceFrom ? 'From $' + Number(s.priceFrom) : 'Profile') + '</span></div></div></a>';
      }).join('');
      tilt(track);
    }).catch(function () {});
  }

  /* Style library: braiders' real portfolio photos replace the stock tiles in order */
  function looks() {
    var g = $('[data-looks]'); if (!g) return;
    home().then(function (d) {
      var list = (d && d.looks) || [], tiles = $$('.bf-g', g);
      list.slice(0, tiles.length).forEach(function (l, i) {
        if (!/^https:\/\//.test(l.photo || '')) return;
        var t = tiles[i], img = $('img', t), b = $('.lab b', t), em = $('.lab em', t), tm = $('.lab .t', t);
        var by = 'by ' + l.name + (l.city ? ' · ' + l.city : '');
        if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = l.photo; img.alt = (l.style || 'Braided style') + ' ' + by; }
        var sub = l.style ? by : (l.city || 'BraidingFest braider');
        if (b) b.textContent = l.style || l.name;
        if (em) em.textContent = sub; else if (b) { em = document.createElement('em'); em.textContent = sub; b.parentNode.appendChild(em); }
        if (tm) tm.textContent = l.likes ? '♥ ' + l.likes : '';
        t.href = safeHref(l.url);
        t.classList.add('real');
      });
    }).catch(function () {});
  }

  /* Featured event button follows the app's featured event */
  function eventLink() {
    var a = $('.bf-event [data-finale-auto]'); if (!a) return;
    home().then(function (d) { var ev = ((d && d.events) || []).filter(function (e) { return e.featured; })[0]; if (ev) a.href = safeHref(ev.url); }).catch(function () {});
  }

  /* Register: role-specific affiliate copy + saves the opt-in to the customer note */
  function register() {
    var form = document.getElementById('BfRegister'); if (!form) return;
    var cb = $('[data-aff]', form), hidden = $('[data-aff-hidden]', form), copy = $('[data-aff-copy]', form);
    function role() { var r = $('input[data-role]:checked', form); return r ? r.getAttribute('data-role') : 'client'; }
    function sync() { if (hidden && cb) hidden.value = cb.checked ? 'Yes' : 'No'; if (copy) copy.textContent = copy.getAttribute('data-' + role()) || copy.textContent; }
    $$('input[data-role]', form).forEach(function (r) { r.addEventListener('change', sync); });
    if (cb) cb.addEventListener('change', sync);
    var zip = $('#RegZip', form); if (zip) zip.addEventListener('input', function () { zip.value = zip.value.replace(/\D/g, '').slice(0, 5); });
    form.addEventListener('submit', sync);
    sync();
  }

  function init() {
    splitHero(); loader(); cursor(); chrome(); parallax(); marquee(); words(); reveal(); tilt(document); drag();
    board(); heroChip(); braiders(); looks(); eventLink(); register();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
